import React, { Component, } from 'react';
import { object, string, func, } from 'prop-types';
import { Helmet, } from 'react-helmet';
import { Switch, Route, } from 'react-router-dom';
import { connect, } from 'react-redux';
import keys from 'lodash/keys';
import TabBar from '../../components/TabBar';
import RankingTable from './components/RankingTable';
import BarChartBlock from './components/BarChartBlock';

import fetchPageApi from './actions/fetchPageApi';

export class Prediction extends Component {
  static propTypes = {
    history: object.isRequired,
    match: object.isRequired,
    fetchPageApi: func.isRequired,
    token: string.isRequired,
    company: string.isRequired,
    prediction: object.isRequired,
  }
  static defaultProps = {

  }
  constructor(props) {
    super(props);
    this.state = {
      initTab: false,
    };
  }
  componentDidMount() {
    const {
      match,
      fetchPageApi,
      token,
      prediction,
      company,
    } = this.props;
    const {
      year,
      month,
    } = match.params;
    if (!prediction[year] || !prediction[year][month]) {
      fetchPageApi(company, year, month, token);
    }
  }
  render() {
    const { prediction, match, } = this.props;
    const { projectId, year, month, } = match.params;
    if (!prediction[year] || !prediction[year][month]) {
      return null;
    }
    const predictionData = prediction[year][month].groups;
    const { footnote, } = prediction[year][month];
    const rankingData = keys(predictionData).reduce((pre, cur) => {
      keys(predictionData[cur].subRegions).forEach((region, idx) => {
        pre.push({
          market: predictionData[cur].name,
          region: predictionData[cur].subRegions[region].name,
          fullName: predictionData[cur].subRegions[region].fullName,
          ranking: predictionData[cur].subRegions[region].ranking,
          renderMarket: idx === 0 ? keys(predictionData[cur].subRegions).length : false,
        });
      });
      return pre;
    }, []);
    const factorData = keys(predictionData).reduce((pre, cur) => {
      keys(predictionData[cur].subRegions).forEach((regionKey) => {
        const region = predictionData[cur].subRegions[regionKey];
        if (!region.factors) return;
        const factors = region.factors.reduce((pre, cur) => {
          pre[cur.name] = cur.value;
          return pre;
        }, {});
        pre.push({
          name: region.name,
          ...factors,
        });
      });
      return pre;
    }, []);
    if (!this.state.initTab) {
      this.props.history.replace(`/${projectId}/${year}/${month}/prediction/ranking`);
      this.setState({ initTab: true, });
    }
    return (
      <div>
        <Helmet>
          <title>月報-本月市場預測結果</title>
        </Helmet>
        <TabBar
          tabs={
            [
              {
                name: 'Ranking',
                url: `${year}/${month}/prediction/ranking`,
              },
              {
                name: 'Factor',
                url: `${year}/${month}/prediction/factors`,
              },
            ]
          }
        />
        <Switch>
          <Route
            path={ `/${projectId}/${year}/${month}/prediction/ranking` }
            component={ () => (
              <RankingTable
                data={ rankingData }
                footnote={ footnote.ranking }
              />
            ) }
          />
          <Route
            path={ `/${projectId}/${year}/${month}/prediction/factors` }
            component={ () => (
              <BarChartBlock
                data={ factorData }
                footnote={ footnote.factor }
              />
            ) }
          />
        </Switch>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    prediction: state.prediction,
    token: state.appState.userToken,
    company: state.appState.company,
  };
}

const dispatchObj = {
  fetchPageApi,
};

export default connect(mapStateToProps, dispatchObj)(Prediction);



// WEBPACK FOOTER //
// ./src/scenes/Prediction/index.js